import { ReferanceAsyncSelect } from './referance-async-select'

export function SelectReferanceCode6({ name }) {
  return <ReferanceAsyncSelect name={name} labelCategory="IP KARTI" />
}
